const AccessKey = 'AKIAVE5FZNLWHHWLYRVK';
const SecretAccessKey = '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';

export {AccessKey, SecretAccessKey};